module.exports = __webpack_public_path__ + "img/activities-2.ae79e04e.jpg";